// ---------------------------------------------
// Hero Mobile Image - VAVE Wear
// ---------------------------------------------
// Tauscht src/srcset des <img> im Hero Banner
// bei Viewport ≤ 749px gegen das mobile Bild.
// ---------------------------------------------

const MOBILE_BREAKPOINT = '(max-width: 749px)';

export function initHeroMobileImage() {
  const containers = document.querySelectorAll('[data-hero-mobile-src]');
  if (!containers.length) return;

  const mq = window.matchMedia(MOBILE_BREAKPOINT);
  const handle = () => swapAll(containers, mq.matches);
  mq.addEventListener('change', handle);
  handle();
}

function swapAll(containers, isMobile) {
  containers.forEach((container) => {
    const img = container.querySelector('img');
    if (!img) return;

    if (isMobile) {
      if (img.dataset.desktopSrc === undefined) {
        img.dataset.desktopSrc = img.getAttribute('src') || '';
        img.dataset.desktopSrcset = img.getAttribute('srcset') || '';
      }
      const newSrc = container.dataset.heroMobileSrc;
      const newSrcset = container.dataset.heroMobileSrcset;
      if (newSrc) img.src = newSrc;
      if (newSrcset) img.srcset = newSrcset;
    } else {
      if (img.dataset.desktopSrc !== undefined) {
        img.src = img.dataset.desktopSrc;
        img.srcset = img.dataset.desktopSrcset;
      }
    }
  });
}
